import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=b817f12c&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=b817f12c&prod&lang=scss&scoped=true"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=b817f12c&prod&lang=css"
import style2 from "./VideoPlayer.vue?vue&type=style&index=2&id=b817f12c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b817f12c",
  null
  
)

export default component.exports